import request from "@/CommonDP/utils/request";

export default {
  // 项目看板
  // 获得标签行数据
  getLabelsData(params) {
    return request.post("/prjKanban/getKanbanTopInfo", params);
  },
  // 获得问题分布统计数据
  getQueScatterData(params) {
    return request.post("/prjKanban/getQuestionDistribution", params);
  },
  // 获得人员问题数统计数据
  getCensusData(params) {
    return request.post("/prjKanban/getPeopleQuestionNum", params);
  },
  // 获得人员计划数统计数据
  getPersonTaskData(params) {
    return request.post("/prjKanban/getPeoplePlanTaskNum", params);
  },
  // 获得部门数据
  getDepartments(enterpriseId) {
    return request.get(`/org/getOrgTree?enterpriseId=${enterpriseId}`);
  },
  // 获得维度数据
  getDimensions() {
    return request.get("/dic/content/list?dicCode=PrjKanbanFilter");
  },
  // 计划进度统计
  getProgress(params) {
    return request.post("/prjKanban/getTaskProgress", params);
  },
  // 计划专业
  getSpecList(taskId) {
    return request.get(`/prjPlanTask/spec/list?taskId=${taskId}`);
  },
  // 人员计划数统计
  getPeoplePlanTaskNum(params) {
    return request.post("/prjKanban/getPeoplePlanTaskNum", params);
  },

  // 企业看板
  // 查询项目区域+区域内项目数量
  getPrjAreaList(params) {
    return request.post("/enterprise/dashboard/getPrjAreaList", params);
  },
  // 获得项目类型
  getPrjType() {
    return request.get("/dic/content/list?dicCode=PrjType");
  },
  // 获得项目等级
  getPrjLevel() {
    return request.get("/dic/content/list?dicCode=PrjLevel");
  },
  // 项目总览-部门承接项目数排名
  getDeptPrjNumDashboard(params) {
    return request.post("/enterprise/dashboard/getDeptPrjNumDashboard", params);
  },
  // 质量看板-顶部数据
  getTopInfo(params) {
    return request.post(
      "/enterprise/dashboard/getPrjQuestionDashboardTopInfo",
      params
    );
  },
  // 质量看板-问题总计
  getQuestionDashboard(params) {
    return request.post("/enterprise/dashboard/getQuestionDashboard", params);
  },
  // 人员看板-人员项目数统计
  getPersonnelPrjNum(params) {
    return request.post(
      "/enterprise/dashboard/getPersonnelPrjNumDashboard",
      params
    );
  },
  // 人员看板-人员问题统计
  getPersonnelQuestionNum(params) {
    return request.post(
      "/enterprise/dashboard/getPersonnelQuestionNumDashboard",
      params
    );
  },
  // 人员看板-人员状态统计
  getPersonnelStatusNum(params) {
    return request.post(
      "/enterprise/dashboard/getDeptPersonnelNumDashboard",
      params
    );
  },
  // 人员看板-人员工时统计
  getPersonnelPersonnelHoursNum(params) {
    return request.post(
      "/enterprise/dashboard/getDeptPersonnelWorkTime",
      params
    );
  },
  // 进度看板-项目计划看板
  getTaskProgress(params) {
    return request.post(
      "/enterprise/dashboard/getTaskProgressDashboard",
      params
    );
  },

  // 看板导出PPT
  exportPPT(params) {
    return request({
      responseType: "blob",
      url: `/enterprise/dashboard/exportPPT`,
      method: "post",
      data: params
    });
  },
  // 看板导出excel
  exportExcel(params) {
    return request({
      responseType: "blob",
      url: `/enterprise/dashboard/exportExcel`,
      method: "post",
      data: params
    });
  }
};
